import { IconBackground, IconBackgroundSizes } from 'components/atoms/IconBackground'
import { Image, Pressable, StyleSheet, View } from 'react-native'
import iconImage from 'assets/images/icon.png'
import Text from "theme/Text";
import React, { useMemo } from 'react'
import { colorList } from 'utils/colors'
import HelperVersion from 'utils/helper-version'
import VStack from 'components/atoms/stack/VStack'
import i18n from 'utils/i18n'

const LunchScannerBanner = ( { setShowActionModal, iconBackground = true, compact = false }) => {
	
	const BannerView = useMemo( () => {
		return (
			<View
				style={ [ styles.banner, compact && styles.bannerCompact ] }>

				<Pressable
					onLongPress={ setShowActionModal.bind( this, true ) }>

					<Image
						source={ iconImage }
						style={ [ styles.bannerImage, compact && styles.bannerImageCompact ] }
					/>
				</Pressable>

				<VStack style={ compact && styles.bannerTitleCompact }>
					<Text style={ [ styles.bannerText, compact && styles.bannerTextCompact ] }>{ i18n.t('app_name') }</Text>
					<Text style={ styles.bannerSubText }>{ HelperVersion.get() }</Text>
				</VStack>
			</View>
		);
	}, [ iconImage, setShowActionModal, compact ] );
	
	if( !iconBackground ) {
		return BannerView;
	}
	
	return (
		<View
			style={ styles.bannerContainer }>
			
			<IconBackground
				iconSize={ IconBackgroundSizes.XL }
				opacity={ 0.2 }>
				
				{ BannerView }
			</IconBackground>
		</View>
	);
}

const styles = StyleSheet.create({
	bannerCompact: { minHeight: 64, height: 'auto', padding: 12 },
	bannerImageCompact: { width: 36, height: 36 },
	bannerTextCompact: { fontSize: 20 },
	bannerTitleCompact: { flex: 1, minWidth: 0 },
	bannerContainer: {
		width: '100%',
		marginBottom: 10
	},
	banner: {
		height: 100,
		padding: 20,
		alignItems: 'center',
		justifyContent: 'center',
		flexDirection: 'row',
	},
	
	bannerImage: {
		width: 60,
		height: 60,
		marginRight: 10
	},
	
	bannerText: {
		fontSize: 30,
		fontWeight: '700',
		color: colorList.WHITE.primary
	},
	bannerSubText: {
		fontSize: 12,
		color: colorList.WHITE.primary
	},
});

export default LunchScannerBanner;
